<div class="clock-container">
  <!-- Time display header -->
  <div class="clock-time-display" role="group" aria-label="Selected time">
    <span
      class="clock-time-segment"
      [class.active]="view === 'hours'"
      role="button"
      tabindex="0"
      aria-label="Select hours"
      (click)="switchToHours()"
      (keydown.enter)="switchToHours()"
      (keydown.space)="switchToHours()"
      >{{ formattedHours }}</span
    >
    <span class="clock-time-separator" aria-hidden="true">:</span>
    <span
      class="clock-time-segment"
      [class.active]="view === 'minutes'"
      role="button"
      tabindex="0"
      aria-label="Select minutes"
      (click)="switchToMinutes()"
      (keydown.enter)="switchToMinutes()"
      (keydown.space)="switchToMinutes()"
      >{{ formattedMinutes }}</span
    >
  </div>

  <!-- Clock Dial -->
  <svg
    #svgEl
    class="clock-dial"
    viewBox="0 0 256 256"
    width="256"
    height="256"
    role="group"
    tabindex="0"
    [attr.aria-label]="
      view === 'hours' ? 'Select hour, 24-hour format' : 'Select minute'
    "
    (click)="onDialClick($event)"
    (keydown)="onDialKeyDown($event)"
  >
    <!-- Clock face -->
    <circle cx="128" cy="128" r="113" class="clock-face" />

    <!-- Minute ticks (minutes view only) -->
    @if (view === 'minutes') {
      @for (tick of minuteTicks; track $index) {
        <line
          [attr.x1]="tick.x1"
          [attr.y1]="tick.y1"
          [attr.x2]="tick.x2"
          [attr.y2]="tick.y2"
          class="clock-tick"
          [class.clock-tick-major]="tick.isMajor"
        />
      }
    }

    <!-- Clock hand line -->
    <line
      class="clock-hand"
      x1="128"
      y1="128"
      [attr.x2]="handEndX"
      [attr.y2]="handEndY"
    />

    <!-- Hand endpoint dot: only shown when selected position has no number label
         (i.e. minutes view with a non-multiple-of-5 value) -->
    @if (view === 'minutes' && minutes % 5 !== 0) {
      <circle
        [attr.cx]="handEndX"
        [attr.cy]="handEndY"
        r="16"
        class="clock-endpoint-dot"
      />
    }

    <!-- Center pivot dot -->
    <circle cx="128" cy="128" r="4" class="clock-center-dot" />

    <!-- Hour / minute number markers — rendered last so they always appear on top -->
    @for (num of clockNumbers; track num.value) {
      <g
        class="clock-number"
        [class.clock-number--selected]="num.isSelected"
        [class.clock-number--inner]="num.isInner"
        role="button"
        [attr.aria-label]="num.label"
        [attr.aria-pressed]="num.isSelected"
      >
        <circle
          [attr.cx]="num.x"
          [attr.cy]="num.y"
          [attr.r]="num.isInner ? 14 : 16"
          class="clock-number-bg"
        />
        <text
          [attr.x]="num.x"
          [attr.y]="num.y"
          class="clock-number-text"
          [style.fill]="
            num.isSelected ? 'var(--white)' : 'var(--color-text-text-primary)'
          "
          [style.font-weight]="num.isSelected ? '700' : '500'"
          dominant-baseline="central"
          text-anchor="middle"
        >
          {{ num.label }}
        </text>
      </g>
    }
  </svg>
</div>
